var _defs, _rect, _animateTransform, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerPlasma6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 2,
    viewBox: "0 0 100 2",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plasma",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--color-secondary, #8B6CFF)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "var(--color-secondary, #8B6CFF)",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "var(--color-accent, #FF2DCB)",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--color-accent, #FF2DCB)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-30%",
    y: "-300%",
    width: "160%",
    height: "700%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 0.6,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 2,
    rx: 1,
    fill: "url(#plasma)",
    filter: "url(#glow)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "-20 0",
    to: "20 0",
    dur: "3s",
    repeatCount: "indefinite"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) {\n      animateTransform { display:none; }\n    }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerPlasma6);
export default __webpack_public_path__ + "static/media/divider-plasma-6.538cff971e2eb6b0e1743129e1c988fb.svg";
export { ForwardRef as ReactComponent };